'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState, useRef } from 'react'

export const LoadingOverlay = () => {
  const pathname = usePathname()
  const [isLoading, setIsLoading] = useState(false)
  const previousPathRef = useRef(pathname)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    // Show loading when pathname changes
    if (pathname !== previousPathRef.current) {
      previousPathRef.current = pathname
      // Clear any existing timer
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      // Defer state update to avoid synchronous setState in effect
      queueMicrotask(() => {
        setIsLoading(true)
        
        // Hide loading after a short delay (navigation should be complete)
        timerRef.current = setTimeout(() => {
          setIsLoading(false)
          timerRef.current = null
        }, 300)
      })
    }
    
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [pathname])

  if (!isLoading) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-lg bg-white p-6 shadow-lg">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-vi-red border-t-transparent" />
        <p className="text-sm font-medium text-gray-700">Updating products...</p>
      </div>
    </div>
  )
}

